import { render, staticRenderFns } from "./customer-suggested-products-list.vue?vue&type=template&id=1101948a&"
import script from "./customer-suggested-products-list.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-suggested-products-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports